


const About = () => {

    return (<div className="aboutDiv">
        <p className="about">
            <span>About the <span className="about1" >company</span> </span><br></br>
            An online store selling all kinds of electronic products in various shapes.. All high-quality products are specially designed to suit your needs at a competitive price that satisfies you. It is normal for high-quality products to have a different price than low-quality products - and we at ECMA.com provide you with high-quality products.<br></br>

            An overview of our site....<br></br>

            First, it is the easiest site ever to access products

            Secondly, you can communicate with us and provide us with everything about the products to reach the highest level of customer satisfaction.<br></br>

            As for third, we have a guarantee on the goods in the company and maintenance in a periodic form.<br></br>

            Fourth, upon request, you will receive the order in less than 48 hours.<br></br>

            Fifthly, the customer can return the goods in the event of any industrial error.<br></br>
        </p>
        <br></br>
        <img className="aboutimg" src="https://res.cloudinary.com/hudhud/image/upload/v1655496474/maxqgc69/ECMA_vxqmns.jpg"  alt="logo for ECMA"/>
    </div>)


}



export default About;